export const sortByOptions = [
  { value: 1, label: 'Item Code' },
  { value: 2, label: 'Item Description' },
];

export const warehouseAvailabilityGroupByOptions = [
  { value: 2, label: 'Distributor' },
  { value: 3, label: 'Storage Location' },
  { value: 4, label: 'Item Group' },
  { value: 5, label: 'Bid Group' },
  { value: 6, label: 'Account Category' },
];

export const warehouseHoldGroupByOptions = [
  { value: 1, label: 'Order #' },
  ...warehouseAvailabilityGroupByOptions,
];

export const onHandTimeOptions = [
  { value: 0, key: 0, text: 'All' },
  { value: 1, key: 1, text: '<= 30 days' },
  { value: 2, key: 2, text: '> 30 days' },
  { value: 3, key: 3, text: '> 60 days' },
  { value: 4, key: 4, text: '> 90 days' },
];
export const availabilityPrintOptions = [
  { value: 2, label: 'Item Code' },
  { value: 3, label: 'Item Description' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/helper/index.js